// Hook usunięcia usługi z pozycji oferty –
// DELETE /sales-crm/clients/:cid/offers/:oid/positions/:pid/services/:id

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  serviceItemId: number
): Promise<IResponse> =>
  axios.delete(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/services/${serviceItemId}`
  );

export const useDeleteSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<IResponse, IError, number>
) =>
  useMutation(
    (serviceItemId: number) =>
      deleteSalesCrmOfferService(clientId, offerId, positionId, serviceItemId),
    options
  );
